import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
// import { Link } from "gatsby"

import { CartWidget } from "../Cart/Widget/CartWidget"
import { SearchWidget } from "../Search/Widget/SearchWidget"
import { AccountWidget } from "../Account/Widget/AccountWidget"
import { withHeaderAccount } from "./withHeaderAccount"
// import { StyledButton } from "../Styled/Button"

const Wrapper = tw.div`w-1/2 md:w-4/9 flex flex-row items-center justify-end`
// const Button = styled(StyledButton)`
//   ${tw`uppercase inline-block py-1 ml-0-6 z-40`}
//   span {
//     align-self: center;
//   }
// `
// const ButtonWrapper = tw.div`mx-1 z-40`
const Desktop = styled.div<DesktopProps>`
  ${({ activeCart }) => (activeCart ? tw`hidden` : tw`hidden md:flex`)}
`
const Mobile = tw.div`flex md:hidden`
// const IconButton = tw(StyledButton)`rounded-full ml-0-6`

const HeaderAccount = withHeaderAccount(({ activeCart, activeHeaderHero, location }) => {
  return (
    <Wrapper>
      <Desktop activeCart={activeCart}>
        {/*
        <ButtonWrapper>
          <Button className={`secondary-button`} as={Link} to={quizUrl} layout={`secondary`} background={`light`} colour={`blue`}>
            {`LET'S GET STARTED!`}
          </Button>
        </ButtonWrapper>
        */}
        <SearchWidget location={location} />
        <AccountWidget />
      </Desktop>

      <Mobile>
        <SearchWidget location={location} activeHeaderHero={activeCart} />
        <AccountWidget activeHeaderHero={activeHeaderHero} />
      </Mobile>

      <CartWidget />
    </Wrapper>
  )
})

export default HeaderAccount

type DesktopProps = {
  activeCart: boolean
}